class ElunoriProductCard extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-el-product-swatch]')];
    this.buttons.forEach((button) => button.addEventListener('click', () => this.selectVariant(button)));
  }

  selectVariant(button) {
    this.buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));

    const image = this.querySelector('[data-el-product-image]');
    if (image && button.dataset.image) {
      image.src = button.dataset.image;
      image.removeAttribute('srcset');
    }

    const links = this.querySelectorAll('[data-el-product-link]');
    if (button.dataset.url) links.forEach((link) => { link.href = button.dataset.url; });

    const price = this.querySelector('[data-el-product-price]');
    if (price && button.dataset.price) price.textContent = button.dataset.price;

    const status = this.querySelector('[data-el-product-status]');
    if (status) status.textContent = `Selected color: ${button.dataset.label}`;
  }
}

if (!customElements.get('elunori-product-card')) {
  customElements.define('elunori-product-card', ElunoriProductCard);
}

